import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop
 * -----------
 * Listens for route changes (pathname or hash) and scrolls the window to
 * top. Drop a single instance inside <BrowserRouter> so it runs on every
 * navigation. Without this, React Router preserves scroll position which
 * surprises users coming from the sidebar.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // hash navigation: let the browser jump to the anchor
    // Use 'instant' on initial render to avoid jarring animation;
    // subsequent navigations get a smooth scroll.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      // Safari < 15 doesn't support 'instant' as a string, fallback
      window.scrollTo(0, 0);
    }

    // Also reset any internal scroll containers (e.g. main content area
    // with its own overflow-y). Each app shell adds the
    // [data-scroll-container] attribute to its main content wrapper.
    document.querySelectorAll('[data-scroll-container]').forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname, hash]);

  return null;
}
